import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import AirPortTicket from '../../../components/AirPortTicket.vue';
import { Dialog } from 'vant';
import Workflow from '../Workflow';
import AirTicketBooking from './AirTicketBooking';
import changeAirport from '../../../assets/js/airport/changeAirport';

@Component({
  components: {
    AirPortTicket,
  },
  // 过滤器 格式化金额
  filters: {
    Date(data: any) {
      return moment(data).format('MM-DD');
    },
    WeekDay(data: any) {
      moment.locale('zh-cn');
      return moment(data).format('dddd');
    },
    Month(data: any) {
      return data ? (moment(data).isSame(moment(), 'month') ? '本月' : moment(data).format('YYYY年MM月')) : '请选择日期';
    },
    City(data: any) {
      // 如果是三字码就转换一下
      return /^[A-Z]{3}$/.test(data) ? (changeAirport.changeAirportCode(data).cityCName || '无') : data;
    },
    OrderState(data: any) {
      const state: any = {
        0: '已申请',
        2: '订票成功',
        3: '订票失败',
        4: '已退票',
        5: '已改签',
        6: '订票中',
        7: '改签中',
        8: '退票中',
      };
      return data && state[data] ? state[data] : '';
    },
  },
})
export default class TripInfoList extends Vue {
  private $api: any;
  private tripinfolist: any = [];
  private loading: boolean = false;
  private pageIndex = 1;
  private status: number = 0; // 0 正常, 1 数据全部加载, 2 加载失败
  private scrollView: any = null; // 记录被滚动的元素
  private userRoleType: number = -1; // 用户类型 0(普通员工) 1(部门经理) 2(订票专员)
  private isLeader: boolean = false;  // 是否为订票专员或部门负责人(用于控制编辑原因按钮)
  private StartTime: any = '';  // 查询的时间
  private NeedType: number = 2;  // tab页控制 1 审批  2 帮订 3 我的 需求查询类型(实际索引是0开始,需要+1)
  private ApprovalType: any = 0; // 审批状态 0 待审批 1 已审批 null 全部
  private UserInfo: any;
  private isManager: boolean = false; // 是否是总经理

  // 时间选择器 - 帮定查询
  private show: boolean = false;
  private minDate: any = new Date('2020-01-01');
  private currentDate: any = new Date();

  // 时间选择器 - 查询
  private showSearch: boolean = false;
  private SearchDate: any = '';
  private currentDateSearch: any = new Date();


  // 审批状态查询
  private ChangeApprovalType(status: any) {
    this.ApprovalType = status;
    this.getTripInfoList(true);
  }

  @Watch('NeedType')
  private onNeedTypeChanged(val: number, oldVal: number) {
    this.ApprovalType = val === 0 ? 0 : '';
    this.getTripInfoList(true);
  }



  // 获取用户信息(撤销行程需要用户信息)
  private async getUserInfo() {
    const result = await this.$api.httpGet('basic/Ticket/QueryCurrentUserInfo');
    if (result.Success) {
      this.UserInfo = result.Data;
    }
  }


  // 获取用户角色，是否为订票专员
  private async getUserIsCommissioner() {
    const result = await this.$api.httpGet('Membership/TripBookTicket/GetIsBookingTicketRole');
    if (result.Success) {
      if (result.Data) {
        this.userRoleType = 2;
        this.getTripInfoList(true);
      } else {
        if (this.userRoleType !== 1) {
          this.userRoleType = 0;
          this.NeedType = 2;  // 改变NeedType会触发列表页查询
          this.getTripInfoList(true);
        } else {
          this.getTripInfoList(true);
        }
      }
    }
  }

  // 获取用户角色，是否为总经理
  private async getUserIsManager() {
    const result = await this.$api.httpGet('Membership/TripInfo/GetJudgeGeneralManagerRole');
    if (result.Success) {
      this.isManager = result.Data;
    }
  }

  // 获取用户角色，是否为部门负责人
  private async getUserIsLeader() {
    const result = await this.$api.httpGet('Membership/TripBookTicket/GetIsLeader');
    if (result.Success) {
      this.userRoleType = result.Data ? 1 : this.userRoleType;
      if (!result.Data) {
        // 不是部门负责人，但也有可能是总经理
        const resultGeneral = await this.$api.httpGet('Membership/TripBookTicket/GetIsDepartGeneralLeaderRole');
        if (resultGeneral.Success) {
          this.userRoleType = resultGeneral.Data ? 1 : this.userRoleType;
        }
      }
      // 预防又是部门负责人/总经理又是订票专员的情况，依次请求
      this.getUserIsCommissioner();
    }
  }

  // 获取用户角色，是否为订票专员或部门负责人(用于判断编辑原因按钮显隐)
  private async getUserIsBookingRoleOrLeader() {
    const result = await this.$api.httpGet('Membership/TripInfo/GetJudgeBookingRoleOrLeader');
    if (result.Success) {
      this.isLeader = result.Data;
    }
  }

  // 获取行程信息列表 clear: 请求前是否清空列表
  private async getTripInfoList(clear: boolean) {
    this.loading = true;  // 显示加载中字样
    this.status = 0;      // 隐藏"没有更多了"，"获取失败"字样
    if (clear) {
      this.pageIndex = 1;
      this.tripinfolist.length = 0;
    }

    const params = {
      // 分页
      NeedType: this.NeedType + 1,
      ApprovalType: this.ApprovalType !== null ? this.ApprovalType : '',
      Datetime: this.StartTime,
      PageIndex: this.pageIndex,
      PageSize: 10,
    };
    // 3.4.10 修改，不区分角色，Tab全部展示，不需要处理数据
    // 如果角色是部门经理 (因为少了‘帮订’按钮，‘我的’按钮索引被减一，传参的时候需要再调整一下)
    // if (this.userRoleType === 1) {
    //   if (params.NeedType === 2) {
    //     params.NeedType = 3;
    //   }
    // }
    const result = await this.$api.httpPost('Membership/TripBookTicket/WeChatListViewByQueryNew', params);
    if (this.NeedType + 1 !== params.NeedType && this.userRoleType !== 1) {
      // 此时已经切换了标签页，不再执行后续动作
      return;
    }
    if (result.Success) {
      if (result.Data && result.Data.length !== 0) {
        for (const item of result.Data) {
          this.tripinfolist.push(item);
        }
        this.status = 0;
      } else {
        this.status = 1;
        this.pageIndex = this.pageIndex - 1;
      }
    } else {
      this.status = 2;
      this.pageIndex = this.pageIndex - 1;
    }
    this.endLoading();
  }

  // 监听滑动到底部
  private onScroll(event: any) {
    this.scrollView = event.target;
    const scrollTop = this.scrollView.scrollTop;
    const clientHeight = this.scrollView.clientHeight;
    const scrollHeight = this.scrollView.scrollHeight;
    // 算法：scrollTop + clientHeight >= scrollHeight
    // 有时候拉到底却不触发事件，为了确保会触发，条件里减去1
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      this.loadNextPage();
    }
  }

  // 加载下一页
  private async loadNextPage() {
    if (this.loading) {
      return;
    }
    this.pageIndex = this.pageIndex + 1;
    this.getTripInfoList(false);
  }

  // 上拉加载结束
  private endLoading() {
    this.loading = false;
    // 回滚 (用于解决无限触发滚动事件的bug)
    if (!this.scrollView) {
      return;
    }
    this.scrollView.scrollTop = this.scrollView.scrollTop - 10;
  }


  // 格式化时间
  private formatter(type: string, value: string) {
    if (type === 'year') {
      return `${value}年`;
    } else if (type === 'month') {
      return `${value}月`;
    }
    return `${value}日`;
  }

  // 弹出时间选择器
  private pickDate() {
    this.show = true;
  }

  private changeDate(value: string) {
    this.StartTime = moment(value).format('YYYY-MM');
    this.cancel();
    this.pageIndex = 1;           // 重置页数索引
    this.getTripInfoList(true);
  }

  // 取消弹窗
  private cancel() {
    this.show = false;
  }

  private clearDate(event: any) {
    event.stopPropagation(); // 阻止事件冒泡，否则会弹出时间选择器
    this.SearchDate = '';
    this.pageIndex = 1;           // 重置页数索引
    this.getTripInfoList(true);
  }

  private needShowBtns(option: any) {
    if (!option) {
      return false;
    }
    if (option.canCancelTripInfo || option.canEditTripInfo || option.canBookingAirTicket) {
      return true;
    } else {
      return false;
    }
  }

  // 删除行程(按钮)
  private deleteTripInfoBtn(trip: any) {
    Dialog.confirm({
      title: '行程信息',
      message: '您真的要删除该行程吗？',
    }).then(() => {
      // on confirm 
      this.deleteTrip(trip);
    });
  }

  // 删除行程
  private async deleteTrip(trip: any) {
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在删除...',
    });
    const params = {
      TripTrafficId: trip.TripTrafficId,
    };
    const result = await this.$api.httpGet('Membership/TripInfo/DeletedTripInfo', params);
    if (result.Success) {
      this.$toast.clear();
      this.$toast('删除成功');
      this.getTripInfoList(true);
    } else {
      this.$toast.clear();
      this.$toast(`删除失败:${result.AllMessages}`);
    }
  }

  // 撤销行程(按钮)
  private cancelTripInfoBtn(trip: any) {
    Dialog.confirm({
      title: '行程信息',
      message: '您真的要撤销该行程吗？',
    }).then(() => {
      // on confirm 
      this.cancelTrip(trip);
    });
  }

  // 撤销行程
  private async cancelTrip(trip: any) {
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在撤销...',
    });
    Workflow.Cancel('0033', trip.TripTrafficId, '', this.UserInfo.Id, this.UserInfo.UserName, (response: any) => {
      this.$toast.clear();
      if (response.Success) {
        this.$toast(`撤销成功`);
        this.getTripInfoList(true);
      } else {
        this.$toast(`工作流撤销失败${response.AllMessages}`);
      }
    }, (error: any) => {
      this.$toast.clear();
    });
  }

  private newTrip() {
    this.$router.push('/tripinfo-new');
    localStorage.removeItem('CurrentTripInfo');
    // this.$router.push({ name: 'tripinfo-new', query: { isAdd: '1' } });
  }

  // 订票专员的 去订票 按钮
  private toBooking() {
    localStorage.setItem('AirTicketFor', 'booking');
    localStorage.setItem('AirTicketTrip', '');
    this.$router.push('/airticket-help');
  }
  // 行程列表内的 去订票 按钮
  private toBookingBtn(trip: any) {
    localStorage.setItem('AirTicketFor', 'booking');
    localStorage.setItem('AirTicketTrip', JSON.stringify(trip));
    localStorage.setItem('CurrentTripInfo', JSON.stringify(trip));
    this.$router.push('/airticket-booking');
  }

  // 检查是否可以重新订票
  private async checkReBookingBtn(trip: any) {
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在检查机票状态...',
    });
    // 检查是否可以重新订票
    const result = await this.$api.httpGet('basic/Ticket/GetReturnTicketStateById', { Id: trip.Id });
    this.$toast.clear();
    if (result.Success) {
      if (result.Data === 2 || result.Data === 6) {
        this.$toast('机票状态已更新');
        this.getTripInfoList(true);
      } else {
        this.toReBookingBtn(trip);
      }
    } else {
      this.$toast(result.AllMessages);
    }
  }

  private toReBookingBtn(trip: any) {
    localStorage.setItem('AirTicketFor', 'rebooking');
    localStorage.setItem('AirTicketTrip', JSON.stringify(trip));
    localStorage.setItem('CurrentTripInfo', JSON.stringify(trip));
    this.$router.push('/airticket-booking');
  }

  // 适配不同角色下的列表高度
  private calcListHeight() {
    if (this.userRoleType === 0) {
      return 'calc(100vh - 120px)';
    } else if (this.userRoleType === 1) {
      return this.NeedType === 1 ? 'calc(100vh - 172px)' : 'calc(100vh - 124px)';
    } else if (this.userRoleType === 2) {
      if (this.NeedType === 0) {
        return 'calc(100vh - 124px)';
      } else if (this.NeedType === 1) {
        return 'calc(100vh - 172px)';
      } else {
        return 'calc(100vh - 172px)';
      }
    }
  }

  // 查看行程
  private showTripInfo(trip: any) {
    if (trip.Option.canShowTripInfo || trip.Option.canShowAirTicket) {
      localStorage.setItem('tripInfo', JSON.stringify(trip));
      this.$router.push('/tripinfo-show');
    } else {
      this.$toast(`暂无行程信息`);
    }
  }

  // 审核行程
  private auditTripInfo(trip: any) {
    if (trip.Option.canExamineTripInfo) {
      localStorage.setItem('tripInfo', JSON.stringify(trip));
      this.$router.push('/tripinfo-audit');
    } else {
      this.$toast(`暂无法审核`);
    }
  }

  // 编辑行程
  private async editTripInfo(trip: any) {
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在读取...',
    });
    const params = {
      TripInfoId: trip.TripTrafficId,
    };
    // 获取行程回显信息
    const result = await this.$api.httpGet('Membership/TripBookTicket/GetSeeTripInfo', params);
    if (result.Success && result.Data) {
      const selectedTrip = result.Data;
      // 获取出差数据源
      const tripResult = await this.$api.httpGet('Membership/TripInfo/GetBussinessTravelInformation');
      if (tripResult.Success) {
        this.$toast.clear();
        const businessTripData = tripResult.Data;
        for (const businesstrip of businessTripData) {
          if (selectedTrip.BusinessTripInfoId === businesstrip.Id) {
            const editTripInfo = {
              TripTrafficId: params.TripInfoId,
              BusinessTripInfoId: businesstrip.Id,
              BusinessTripInfoText: moment(businesstrip.BeginAt).format('YYYY-MM-DD'),
              StartAirport: selectedTrip.StartAirport,
              EndAirport: selectedTrip.EndAirport,
              StartTime: moment(selectedTrip.StartTime).format('YYYY-MM-DD'),
              TripWorkflowStatus: trip.TripWorkflowStatus,
            };
            localStorage.setItem('EditTripInfo', JSON.stringify(editTripInfo));
            this.$router.push('/tripinfo-edit');
          }
          break;
        }
      } else {
        this.$toast.clear();
        this.$toast(tripResult.AllMessages);
      }

    } else {
      this.$toast.clear();
      this.$toast(result.AllMessages);
    }
  }

  // 编辑原因
  private auditReason(trip: any) {
    if (trip.Option.canEditReasons) {
      localStorage.setItem('tripInfo', JSON.stringify(trip));
      this.$router.push('/audit-reason');
    } else {
      this.$toast(`暂无法审核`);
    }
  }

  // 审核机票
  private auditAirTicket(trip: any) {
    if (trip.Option.canExamineAirTicket) {
      localStorage.setItem('tripInfo', JSON.stringify(trip));
      this.$router.push('/audit-airTicket');
    } else {
      this.$toast(`暂无法审核`);
    }
  }

  // 提交订单(机票工作流开启失败)
  private toReSubmitWorkFlow(trip: any) {
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在提交...',
    });
    // 重置再提
    Workflow.Reset(trip.Id, (resetResponse: any) => {
      if (resetResponse.Success) {
        // 提交工作流
        Workflow.Submit('0034', trip.Id, (response: any) => {
          if (response.Success && response.Data) {
            this.$toast.clear();
            // 延时三秒发送企业微信通知
            setTimeout(() => {
              /**
               * 运维需求-去掉前台发消息功能
               */
              // this.SendMessageSubmit(trip.Id);
            }, 3000);
            Dialog.alert({
              message: '提交成功',
              confirmButtonText: '确定',
            }).then(() => {
              // on close
              this.getTripInfoList(true);
            });
          } else {
            this.$toast.clear();
            this.$toast(`工作流开启失败:${response.AllMessages}`);
          }
        }, (error: any) => {
          this.$toast.clear();
          this.$toast(`工作流开启失败:${error}`);
        });
      } else {
        this.$toast.clear();
        this.$toast(`提交失败:${resetResponse.AllMessages}`);
      }
    }, (error: any) => {
      this.$toast.clear();
      this.$toast(`工作流重置失败:${error}`);
    });
  }

  /**
   * 运维需求-去掉前台发消息功能
   */
  // 发送企业微信通知(提交订单)
  // private async SendMessageSubmit(TripTrafficId: string) {
  //   const result = await this.$api.httpGet('Membership/TripBookTicket/SendTicketMessageSubmit', { Id: TripTrafficId });
  //   if (result.Success) {
  //     // this.$toast('行程信息: 已发送通知至企业微信');
  //   } else {
  //     if (result.AllMessages !== 'draft') {
  //       this.$toast(`行程信息: ${result.AllMessages}`);
  //     }
  //   }
  // }

  // 初始化
  private created() {
    // if (this.$store.state.needClearRouters) {
    //   location.reload();
    // }

    this.getUserIsManager();
    this.getUserIsLeader();
    this.getUserIsBookingRoleOrLeader();
    this.getUserInfo();
  }

}
